//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "Table",
	props: {
		contacts: Array
	},
	computed: {
    sortedContacts() {
      return this.contacts
        .sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === "descending") modifier = -1;
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        });
    },
		contactsHaveHeadshots() {
			return this.contacts.some(c => !!c.headshot);
		},
	},
	data() {
		return {
			currentSort: this.$root.sortProperty || "serviceName",
			currentSortDir: this.$root.sortOrder || "ascending",
		};
	},
	methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "ascending" ? "descending" : "ascending";
      }
      this.currentSort = s;
      this.currentPage = 1;
    },
	},
	created() {},
};
